<mat-card [class.mh-250]="this.recentActivity && this.recentActivity?.length > 0 && !loading"
          class="overflow-hidden recentActivityCard halfSideBar">
    <mat-card-header [style.background-color]="community?.recent_activity_header_bg_color_hex" class="noDarkMode">
        <div mat-card-avatar>
            <mat-icon
                    [style.color]="this.themeService.getReadableColor(community?.recent_activity_header_bg_color_hex)">
                access_time
            </mat-icon>
        </div>
        <mat-card-title
                [style.color]="this.themeService.getReadableColor(community?.recent_activity_header_bg_color_hex)">
            <div [innerHTML]="community?.recent_activity_tile_name_rendered || 'Recent activity'"
                 class="noMargin"></div>
        </mat-card-title>
    </mat-card-header>
    @if (isDialog) {
        <div class="float-end">
            <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                    tabindex="-1">
                <mat-icon
                        [style.color]="this.themeService.getReadableColor(community?.recent_activity_header_bg_color_hex)"
                        class="accent-text">
                    close
                </mat-icon>
            </button>
        </div>
    }
    <mat-card-content class="activityScroll pt-10">
        @if (loading) {
            <div class="flex-row justify-content-center">
                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            </div>
        }
        <div class="flex-col w-100">
            @for (content of this.recentActivity; track content; let last = $last) {
                <div class="flex-row w-100 gap-15">
                    <div class="flex-col align-items-center">
                        <div class="circle"></div>
                        @if (!last) {
                            <div class="line"></div>
                        }
                    </div>
                    <div (click)="link(content)" class="flex-col pb-15 clickable flex-1 p-5">
                        @if (content.type == 'comment') {
                            <p class="m-0">
                                {{ content.related_objects?.comment?.author?.username }} commented on
                                {{ content.related_objects?.post?.title }}</p>
                        }
                        @if (content.type == 'comment_liked') {
                            <p class="m-0">
                                New like on {{ content.related_objects?.comment?.author?.username }}'s
                                comment</p>
                        }
                        @if (content.type == 'post_liked') {
                            <p class="m-0">New like on post
                                {{ content.related_objects?.post?.title }}</p>
                        }
                        @if (content.type == 'post') {
                            <p class="m-0">New post available
                                {{ content.related_objects?.post?.title }}</p>
                        }
                        <small class="muted d-flex align-items-center mt-10 icon">
                            @if (content.type == 'comment') {
                                <mat-icon>question_answer</mat-icon>
                            }
                            @if (content.type == 'comment_liked' || content.type == 'post_liked') {
                                <mat-icon
                                >
                                    favorite
                                </mat-icon>
                            }
                            @if (content.type == 'post') {
                                <mat-icon>library_books</mat-icon>
                            }
                            &nbsp;&nbsp;{{ content.created_at | date: 'MMM d, h:mm a' }}</small>
                    </div>
                </div>
            }
            @if (this.recentActivity && this.recentActivity?.length == 0 && (!loading && loading != null)) {
                <div
                        class="flex-row w-100 gap-15">
                    <div class="flex-col pb-15">
                        <small class="m-0">You have no recent activities</small>
                    </div>
                </div>
            }
        </div>
    </mat-card-content>
</mat-card>
